import { render } from "./TableBase.vue?vue&type=template&id=6006af1f&scoped=true"
import script from "./TableBase.vue?vue&type=script&lang=js"
export * from "./TableBase.vue?vue&type=script&lang=js"

import "./TableBase.vue?vue&type=style&index=0&id=6006af1f&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6006af1f"]])

export default __exports__